import { useUiLanguage } from "@/i18n/useUiLanguage";
import { systemText, tr } from "@/i18n/copy";
import {useEffect, useId, useRef, useState} from 'react';
import {Button} from '@/components/ui/button';
let library;
export function loadBarcodeLibrary() {
  if(window.Html5Qrcode)return Promise.resolve(window.Html5Qrcode);
  if(library)return library;
  library=new Promise((resolve,reject)=>{
    const script=document.createElement('script');
    script.src='https://cdn.jsdelivr.net/npm/html5-qrcode@2.3.8/html5-qrcode.min.js';script.async=true;script.crossOrigin='anonymous';
    const timeout=setTimeout(()=>{script.remove();reject(Error(tr("Lettore non disponibile. Inserisci il codice manualmente.")));},15000);
    script.onload=()=>{clearTimeout(timeout);window.Html5Qrcode?resolve(window.Html5Qrcode):reject(Error(tr("Lettore non disponibile.")));};
    script.onerror=()=>{clearTimeout(timeout);script.remove();reject(Error(tr("Impossibile caricare il lettore. Inserisci il codice manualmente.")));};
    document.head.appendChild(script);
  }).catch(e=>{library=null;throw e;});
  return library;
}
export default function ProductBarcodeScanner({onCode}) {
  useUiLanguage();
  const id='warehouse-camera-'+useId().replace(/:/g,'');const callback=useRef(onCode);callback.current=onCode;
  const [camera,setCamera]=useState(false),[error,setError]=useState(''),[code,setCode]=useState('');
  useEffect(()=>{
    if(!camera)return;
    let cancelled=false,reader,started=false,done=false;
    const stop=async()=>{if(reader){if(started){started=false;try{await reader.stop();}catch{}}try{reader.clear();}catch{}}};
    (async()=>{try{
      const Reader=await loadBarcodeLibrary();if(cancelled)return;
      const formats=window.Html5QrcodeSupportedFormats;
      reader=new Reader(id,{verbose:false,formatsToSupport:formats?[formats.EAN_13,formats.EAN_8,formats.UPC_A,formats.UPC_E,formats.CODE_128,formats.CODE_39]:undefined});
      await reader.start({facingMode:'environment'},{fps:8},text=>{if(done||cancelled)return;done=true;setCode(text);setCamera(false);callback.current(text);},()=>{});
      started=true;if(cancelled)await stop();
    }catch(e){if(!cancelled){setError(tr("Fotocamera non disponibile. Consenti l’accesso oppure digita il codice / usa un lettore esterno."));setCamera(false);}}})();
    return()=>{cancelled=true;stop();};
  },[camera,id]);
  return <section className="space-y-3 rounded-xl border p-4"><h2 className="font-semibold">{tr("Scanner prodotti")}</h2><p className="text-sm text-muted-foreground">{tr("Inquadra il codice a barre oppure usa un lettore esterno nel campo. Lotto e scadenze si verificano sulla confezione.")}</p>
    <form className="flex gap-2" onSubmit={e=>{e.preventDefault();if(code.trim()){setCamera(false);onCode(code.trim());}}}><input aria-label={tr("Codice a barre")} maxLength={64} className="min-w-0 flex-1 rounded-lg border bg-background p-2" value={code} onChange={e=>setCode(e.target.value)} autoComplete="off"/><Button type="submit" disabled={!code.trim()}>{tr("Cerca codice")}</Button></form>
    <Button variant="outline" onClick={()=>{setError('');setCamera(!camera);}}>{camera?tr("Chiudi fotocamera"):tr("Scansiona con fotocamera")}</Button>
    {error&&<p role="alert" className="text-sm text-amber-400">{systemText(error)}</p>}<div id={id} className={camera?'max-w-lg overflow-hidden rounded-xl':'hidden'}/>
  </section>;
}
